export enum WidgetFatalErrorCategoryEnum {
  Auth = 'auth'
}
